// import { live, chat } from '@/api'
import {
    getUserSig
} from '@/api/live'
import { allocationCustomerServiceNew } from '@/api'
import { getUserSigTourist } from '@/api'
import { filterCallingMessage } from '@/utils/funcTim'
import { Message } from 'element-ui'
import i18n from '@/utils/i18n'

const state = () => ({
    timIsLogin: false, // im是否登录
    isSDKReady: false, // TIM SDK 是否 ready
    chatDialogVisible: false, // 聊天会话框
    currentTime: Date.now(), // 当前时间
    currentUserProfile: {}, // 当前用户IM信息
    userInfo: {}, // 当前聊天人信息
    customerServiceInfo: null, // 游客在线客服 （进入项目、刷新页面即分配客服）
    currentConversation: {}, // 当前会话
    currentMessageList: [], // 当前消息列表
    nextReqMessageID: '',
    isCompleted: false, // 当前会话消息列表是否已经拉完了所有消息
    conversationList: [], // 左侧 会话列表
    audioCall: false,
    isShowConversationList: false,
    selectedMessageList: [],
    relayType: 1, // 1: 转发  2: 逐条转发 3: 合并转发
    mergerMessageList: [],
    mergerMessage: {},
    relayMessage: {},
    selectMessage: false, // 选择消息
    message: undefined, // 提示消息
    callingInfo: {
        memberList: [],
        type: 'C2C' // C2C，GROUP
    },
    videoRoom: 0,
    showList: false,
    currentConversationInfo: {}, // 当前对话人信息

    newMessageComing: false,
    newMailComing: false,

})

const mutations = {
    setCurrentConversationInfo(state, currentConversationInfo) {
        console.log('currentConversationInfo--->', currentConversationInfo)
        state.currentConversationInfo = currentConversationInfo
    },
    toogleShowList(state, showList) {
        state.showList = showList
    },
    toogleChatDialog(state) {
        state.chatDialogVisible = !state.chatDialogVisible
    },
    toggleIsLogin(state, timIsLogin) {
        state.timIsLogin = typeof timIsLogin === 'undefined' ? !state.timIsLogin : timIsLogin
    },
    toggleIsSDKReady(state, isSDKReady) {
        state.isSDKReady = typeof isSDKReady === 'undefined' ? !state.isSDKReady : isSDKReady
    },
    setUserInfo(state, payload) {
        state.userInfo = payload
    },
    // 保存客服信息
    setCustomerServiceInfo(state, payload) {
        state.customerServiceInfo = payload
    },
    showConversationList(state, value) {
        state.isShowConversationList = value
    },
    setSelectedMessageList(state, value) {
        // state.selectedMessageList = Object.assign([], value)
        state.selectedMessageList = deepClone(value)
    },
    setRelayType(state, value) {
        state.relayType = value
    },
    setMergerMessage(state, value) {
        state.mergerMessage = value
        state.mergerMessageList = [...state.mergerMessageList, value]
    },
    setRelayMessage(state, value) {
        state.relayMessage = value
    },
    updateMergerMessage(state, value) {
        state.mergerMessage = value
        state.mergerMessageList.pop()
    },
    setSelectedMessage(state, value) {
        state.selectMessage = value
    },
    resetSelectedMessage(state, value) {
        state.selectMessage = value
        Object.assign(state, {
            selectedMessageList: []
        })
    },
    setNextReqMessageID(state, value) {
        state.nextReqMessageID = value
    },
    setIsCompleted(state, value) {
        state.isCompleted = value
    },
    setCurrentMessageList(state, value) {
        state.currentMessageList = value
    },
    resetMergerMessage(state, value) {
        state.mergerMessagePop = value
        Object.assign(state, {
            mergerMessage: {},
            mergerMessageList: []
        })
    },
    /**
     * 显示trtcCalling 语音通话
     * @param {Object} state
     * @param {Conversation} showAudioCall
     */
    showAudioCall(state, value) {
        state.audioCall = value
    },
    /**
     * 更新当前会话
     * 调用时机: 切换会话时
     * @param {Object} state
     * @param {Conversation} conversation
     */
    updateCurrentConversation(state, conversation) {
        state.currentConversation = conversation
        state.currentMessageList = []
        state.nextReqMessageID = ''
        state.isCompleted = false
    },
    /**
     * 更新会话列表
     * 调用时机：触发会话列表更新事件时。CONVERSATION_LIST_UPDATED
     * @param {Object} state
     * @param {Conversation[]} conversationList
     */
    updateConversationList(state, conversationList) {
        // vuex 关闭严格模式
        console.log('======================会话列表==============')
        console.log(conversationList)
        state.conversationList = conversationList.filter(item => item.lastMessage.lastTime !== 0)
        // state.conversationList = conversationList

        console.log('*******', state)
        // dispatch('getAAA')
        // TODO
        setTimeout(() => {
            
            let count = 0
            conversationList.forEach(element => {
                count+=element.unreadCount
            })
            if (count != 0) {
                state.newMessageComing = true
                // this.$store.commit('setNewMessageStatus', true)
            } else {
                state.newMessageComing = false
                // this.$store.commit('setNewMessageStatus', false)
            }
        },0)
    },

    setNewMessageStatus(state, payload) {
        state.newMessageComing = payload
    },

    setNewMailStatus(state, payload) {
        state.newMailComing = payload
    },
    /**
     * 重置当前会话
     * 调用时机：需要重置当前会话时，例如：当前会话是一个群组，正好被踢出群时（被踢群事件触发），重置当前会话
     * @param {Object} state
     */
    resetCurrentConversation(state) {
        state.currentConversation = {}
    },
    /**
     * 将消息插入当前会话列表
     * 调用时机：收/发消息事件触发时
     * @param {Object} state
     * @param {Message[]|Message} data
     * @returns
     */
    pushCurrentMessageList(state, data) {
        // 还没当前会话，则跳过
        if (!state.currentConversation.conversationID) {
            return
        }
        if (Array.isArray(data)) {
            // 筛选出当前会话的消息
            const result = data.filter(item => item.conversationID === state.currentConversation.conversationID)
            // state.currentMessageList = [...state.currentMessageList, ...result]
            // filterCallingMessage(state.currentMessageList)
            // 过滤数据
            const arr = [...state.currentMessageList, ...result]
            const newArr = arr.reduce(function (tempArr, item) {
                if (tempArr.findIndex((ele) => ele.ID === item.ID) === -1) {
                    tempArr.push(item)
                }
                return tempArr
            }, [])
            state.currentMessageList = [...newArr]
            filterCallingMessage(state.currentMessageList)

        } else if (data.conversationID === state.currentConversation.conversationID) {
            state.currentMessageList = [...state.currentMessageList, data]
            filterCallingMessage(state.currentMessageList)
        }
    },
    /**
     * 从当前消息列表中删除某条消息
     * @param {Object} state
     * @param {Message} message
     */
    removeMessage(state, message) {
        const index = state.currentMessageList.findIndex(({ ID }) => ID === message.ID)
        if (index >= 0) {
            state.currentMessageList.splice(index, 1)
        }
    },
    loginReset(state) {
        Object.assign(state, {
            currentUserProfile: {},
            timIsLogin: false,
            isSDKReady: false // TIM SDK 是否 ready
        })
    },
    reset(state) {
        Object.assign(state, {
            currentConversation: {},
            currentMessageList: [],
            nextReqMessageID: '',
            isCompleted: false, // 当前会话消息列表是否已经拉完了所有消息
            conversationList: []
        })
    },
    updateCurrentUserProfile(state, userProfile) {
        state.currentUserProfile = deepClone(userProfile)
    },
    showMessage(state, options) {
        if (state.message) {
            state.message.close()
        }
        state.message = Message({
            message: options.message,
            type: options.type || 'success',
            duration: options.duration || 2000,
            offset: 40
        })
    },
    setCallingList(state, value) {
        state.callingInfo.memberList = value.memberList
        state.callingInfo.type = value.type
    },
    GENERATE_VIDEO_ROOM(state, videoRoom) {
        if (videoRoom) {
            state.videoRoom = videoRoom
        } else {
            state.videoRoom = Math.ceil(Math.random() * (2 ** 32 - 1))
        }
    },
    UPDATE_ISBUSY(state, isBusy) {
        state.isBusy = isBusy
    }
}

const actions = {
    // 获取会话人信息
    async getOnlineCustomer({
        commit,
        dispatch,
        rootState
    }, isLogin) {
        console.log('isLogin--->', isLogin)
        if (isLogin) {
            console.log('HHHHHHHHHHHHHHHHHHH', rootState)
            const userInfo = rootState.user.info
            if (userInfo.userAccountId) {
                const userSig = await getUserSig().then(res => {
                    return res.data
                })
                console.log('登录后-userSig', userSig.data)

                const paramsObj = {
                    userID: userInfo.userAccountId,
                    userSig: userSig.data
                }
                await commit('setUserInfo', {
                    ...paramsObj,
                    ...userInfo
                })
                console.log('登陆后paramsObj---->', paramsObj)
                await dispatch('chatLogin', paramsObj)
            }
        } else {
            console.log('游客信息--->', rootState.user.info)
            console.log(sessionStorage.getItem('touristInfo'))
            let userID
            let userSig
            if (sessionStorage.getItem('touristInfo')) {
                console.log('有值')
                const tourists = JSON.parse(sessionStorage.getItem('touristInfo'))
                userID = tourists.userAccountId
                userSig = tourists.userSig

                console.log('userID---', userID)
                console.log('userSig---', userSig)
                const params = {
                    userID,
                    userSig
                }
                console.log('params---', params)

                await commit('setUserInfo', {
                    ...params,
                    name: i18n.t('游客')
                })
                setTimeout(() => {
                    dispatch('chatLogin', params)
                }, 10)
            } else {
                console.log('没值')
                // // 获取游客userID userSig
                const tourists = await getUserSigTourist().then(res => {
                    return res.data
                })
                console.log('游客-tourists', tourists)
                if (tourists && tourists.code != 1000) {
                    console.log('获取游客信息失败！')
                    return i18n.t('获取游客信息失败')
                }
                // const { userAccountId: userID, userSig } = tourists.data
                userID = tourists.data.userAccountId
                userSig = tourists.data.userSig
                sessionStorage.setItem('touristInfo', JSON.stringify(tourists.data))

                console.log('userID---', userID)
                console.log('userSig---', userSig)
                const params = {
                    userID,
                    userSig
                }
                console.log('params---', params)
                await commit('setUserInfo', {
                    ...params,
                    name: i18n.t('游客')
                })
                await dispatch('chatLogin', params)
            }
            // // 获取游客userID userSig
            // const tourists = await getUserSigTourist().then(res => {
            //     return res.data
            // })
            // console.log('游客-tourists', tourists)
            // if (tourists && tourists.code != 1000) {
            //     console.log('获取游客信息失败！')
            //     return '获取游客信息失败！'
            // }
            // // const { userAccountId: userID, userSig } = tourists.data
            // const userID = tourists.data.userAccountId
            // const userSig = tourists.data.userSig
            // console.log('userID---', userID)
            // console.log('userSig---', userSig)
            // const params = {
            //     userID,
            //     userSig
            // }
            // console.log('params---', params)
            // await commit('setUserInfo', {
            //     ...params,
            //     name: '游客'
            // })
            // await dispatch('chatLogin', params)
        }
        console.log('获取在线客服信息开始')
        // 获取在线客服信息
        const res = await allocationCustomerServiceNew().then(res => {
            return res.data
        }).catch((res) => {
            console.log('res--->', res)
            return res
        })
        console.log('线客服信息--->', res)
        if (res && res.code != 1000) {
            return i18n.t('获取在线客服信息失败')
        }
        const customerService = res.data[0]
        console.log('res----->', res)
        await commit('setCustomerServiceInfo', customerService)
    },
    async chatLogin({ commit }, payload) {
        console.log('startTime:', new Date())
        console.log('payload--->', payload)
        console.log('window.$TIM---->', window)
        const imResponse = await window.$TIM.login(payload).catch((imError) => {
            console.warn('IM登录失败:', imError)
        })
        commit('toggleIsLogin', true)
        console.log(imResponse, 'IM登录成功')

        // if (imResponse.data.repeatLogin === true) {
        //     // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
        //     console.log('重复登录！')
        // }
    },
    /**
     * 获取消息列表
     * 调用时机：打开某一会话时或下拉获取历史消息时
     * @param {Object} context
     * @param {String} conversationID
     */
    getMessageList(context, conversationID) {
        // 
        if (context.state.isCompleted) {
            context.commit('showMessage', {
                message: i18n.t('已经没有更多的历史消息了哦'),
                type: 'info'
            })
            return
        }
        const { nextReqMessageID, currentMessageList } = context.state
        window.$TIM.getMessageList({ conversationID, nextReqMessageID, count: 15 }).then((imReponse) => {
            // 更新messageID，续拉时要用到
            context.commit('setNextReqMessageID', imReponse.data.nextReqMessageID)
            context.commit('setIsCompleted', imReponse.data.isCompleted)
            // 更新当前消息列表，从头部插入
            const messageList = [...imReponse.data.messageList, ...currentMessageList]
            context.commit('setCurrentMessageList', messageList)

            filterCallingMessage(context.state.currentMessageList)
        })
    },
    /**
       * 切换会话
       * 调用时机：切换会话时
       * @param {Object} context
       * @param {String} conversationID
       */
    checkoutConversation(context, conversationID) {
        context.commit('resetSelectedMessage', false)
        // 1.切换会话前，将切换前的会话进行已读上报
        // if (context.state.currentConversation.conversationID) {
        //     const prevConversationID = context.state.currentConversation.conversationID
        //     window.$TIM.setMessageRead({ conversationID: prevConversationID })
        // }
        // 2.待切换的会话也进行已读上报
        window.$TIM.setMessageRead({ conversationID })

        // 3. 获取会话信息
        return window.$TIM.getConversationProfile(conversationID).then(({ data }) => {
            // 3.1 更新当前会话
            context.commit('updateCurrentConversation', data.conversation)
            // 3.2 获取消息列表
            context.dispatch('getMessageList', conversationID)
            return Promise.resolve()
        })
    },
    setMessageRead(context) {
        const conversationID = context.state.currentConversation.conversationID
        if (!conversationID) {
            return
        }
        window.$TIM.setMessageRead({ conversationID }).then(() => {
            console.log('==============某会话下未读消息已读上报==============')
        }).catch((imError) => {
            console.warn('setMessageRead error:', imError)
        })
    },
}

function deepClone(target) {
    // 定义一个变量
    let result
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = [] // 将result赋值为一个数组，并且执行遍历
            for (const i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]))
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {}
            for (const i in target) {
                result[i] = deepClone(target[i])
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target
    }
    // 返回最终结果
    return result
}

export default {
    namespace: true,
    state,
    actions,
    mutations
}
